import { queries as calendarQueries } from "domains/hire/containers/HiringScheduleCalendar/queries";
import { queries as filtersQueries } from "domains/hire/containers/HiringScheduleFilters/queries";
import { queries as interviewSheetMobileQueries } from "domains/hire/containers/InterviewSheetMobileContainer/queries";
import { queries as interviewSidebarQueries } from "domains/hire/containers/InterviewSidebar/queries";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { calendarDate: Date; availability?: string };

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  ...calendarQueries(input),
  ...filtersQueries(input),
  ...interviewSidebarQueries(input),
  ...interviewSheetMobileQueries(input),
];
